export default __webpack_public_path__ + "static/media/IMG_2833_2.baca3e24.jpg";